<template>
  <div>
    <div class="style_h3"><span>Раздел «Загрузка и проверка публикаций по данным системы SCOPUS»</span></div>
    <div>
      <table class="table_1">
          <tr class="no_line_tr">
            <td class="table_up" tyle="width:70%;">
              <PublicationsAPIpubl/>
              <PublicationsNSTUpubl/>
              <PublicationsIntermediate/>
            </td>
            <td class="td_style_massage_download_help" style="width:30%;">
              <table class="table_message_download_help">
                <caption class="message_download_help">Справка о процедуре загрузки и проверки данных о публикациях из SCOPUS в БД НГТУ</caption>
                  <td>
                  <tr class="message_description_2">Операция загрузки и проверки данных о публикациях осуществляется в 2 этапа: <br> • 1 – загрузка данных о публикациях из системы Scopus в промежуточную базу данных* (БД); <br> •  2 – загрузка и проверка данных о публикациях в БД НГТУ на основании данных, содержащихся в промежуточной БД.</tr>
                  <tr class="message_description_2">В автоматическом режиме в личный кабинет сотрудников НГТУ вносятся данные о тех публикациях, у которых: 1) хотя бы 1 автор имеет аффилиацию НГТУ и идентификатор 'Scopus AuthorID' в личном кабинете сотрудника в системе НГТУ; 2) источник работы – периодическое издание, внесенное в словарь журналов НГТУ; 3) тип работы – статья (article), материалы конференции (conference paper) или обзорная статья (review).</tr>
                  <tr class="message_description_2">Все загружаемые в автоматическом режиме данные о публикациях находятся в БД НГТУ в статусе 'на редактировании' у соответствующих авторов для возможности внесения недостающих данных, к которым может относиться, например, поле "название госзадания".
                  <br>Данные о публикациях будут доступны библиографам в пункте <a class="link_color" target="_blank" href="https://ciu.nstu.ru/library_admin/publication/publication_list">'Список научных публикаций'</a> (раздел 'Проверка печатных работ') после того, как автор соответствующей публикации отправит ее на проверку в библиотеку.
                  <tr class="message_description_2">По окончании выполнения 2 этапа формируется отчет, выгружаемый в формате MS Excel, содержащий информацию о всех внесенных изменениях в БД НГТУ, а также выявленных несостыковках в данных для уже имеющихся публикаций в БД НГТУ. Отчеты доступны для скачивания на текущей странице в пункте "Архив отчетов о загрузке и проверке данных о публикациях в БД НГТУ"</tr>
                  <tr class="message_description_02">*промежуточная БД представляет собой локальную копию метаданных публикаций с аффилиацией НГТУ, выгруженных из системы Scopus. Она необходима для обращения к метаданным публикаций при их сверки с данными в БД НГТУ без расходования квоты (что происходит при прямом обращении к Scopus)</tr>
                    <tr class="message_description_02">**Алгоритм автоматической загрузки и проверки метаданных публикаций позволяет:<br>
                      – исключать повторное внесение данных о тех публикациях, которые фактически уже имеются в БД организации, но внесены не полностью и/или с ошибками (в т.ч. без уникальных идентификаторов и ошибками в названии работы);<br>
                      – выявлять ошибки и несостыковки в данных. Например, обнаружение «лишних» и «недостающих» авторов с аффилиацией НГТУ;<br>
                      – осуществлять внесение недостающих идентификаторов для имеющихся публикаций («id Scopus источника публикации», «e_id Scopus», «DOI») ;<br>
                      – выполнять перезапись идентификаторов публикации («e_id Scopus», «DOI»).</tr>
                  </td>
              </table>
            </td>
          </tr>
      </table>
    </div>
  </div>
</template>

<style>
  .no_line_tr {
    border: none;
  }
  .table_up {
    vertical-align: top; /* содержимое поднимется к его же верхней границе*/
  }
  .style_h3 {
    background: #e5e3d9;
    padding: 2px 2px;
    text-align: center;
    font-size: 120%;
    font-family: 'Times New Roman', Times, serif;
    font-weight:bold;
  }
  .link_color {
    color: #013f28; /* Цвет обычной ссылки */
    text-decoration: underline; /* Убираем подчеркивание у ссылок underline; /* Добавляем подчеркивание */
  }
  .td_style_massage_download_help {
    vertical-align: top;
    /*border: 1px solid black;*/
  }
  .table_all tr {
    border: none;
  }
  /*table, th, td, tr {*/
  /*  border: 1px solid black;*/
  /*}*/
  hr {
    border: none; /* Убираем границу */
    background-color: #D3D3D3; /* Цвет линии */
    color: #D3D3D3; /* Цвет линии для IE6-7 */
    height: 1px; /* Толщина линии */
  }
  .message_download_help {
    color: darkred;
    font-family: 'Times New Roman', Times, serif; /* Гарнитура текста */
    font-size: 120%; /* Размер шрифта в процентах */
    font-weight: normal; /* Нормальное начертание bold */
    border: 1px solid #E7D5C0;
    background-color: #E7D5C0;
  }
  .message_description_02{
    color: black;
    font-family: 'Times New Roman', Times, serif; /* Гарнитура текста */
    font-size: 90%; /* Размер шрифта в процентах */
    font-weight: normal; /* Нормальное начертание */
    text-align:justify;
    border: none;
    line-height: 1.2em;
    /*border: 1px solid black;*/
    /*padding: 5px; /* Поля вокруг текста *!*/
    /*vertical-align: top; /*  содержимое поднимется к его же верхней границе*!*/
  }
  .message_description_2{
    color: black;
    font-family: 'Times New Roman', Times, serif; /* Гарнитура текста */
    font-size: 110%; /* Размер шрифта в процентах */
    font-weight: normal; /* Нормальное начертание */
    text-align:justify;
    /*border: 1px solid black;*/
    /*padding: 5px; /* Поля вокруг текста *!*/
    /*vertical-align: top; /*  содержимое поднимется к его же верхней границе*!*/
  }
  .message_description_024{
    line-height: 1.1em;
    font-family: 'Times New Roman', Times, serif; /* Гарнитура текста */
    font-size: 110%; /* Размер шрифта в процентах */
    font-weight: normal; /* Нормальное начертание */
    color: #013f28;
    text-align:justify;
    /*border: 1px solid black;*/
    /*padding: 5px; /* Поля вокруг текста *!*/
    /*vertical-align: top; /*  содержимое поднимется к его же верхней границе*!*/
  }
  .table_message_download_help {
    border: 2px solid #E7D5C0;
    width:100%;
    padding: 4000px;
    /*vertical-align: top; !*  содержимое поднимется к его же верхней границе*!*!*/
  }
  .table_message_download_help td {
    padding: 4px;
    /*vertical-align: top; !*  содержимое поднимется к его же верхней границе*!*!*/
  }
</style>

<script>
import PublicationsAPIpubl from '@/components/PublicationsAPIpubl'
import PublicationsNSTUpubl from '@/components/PublicationsNSTUpubl'
import PublicationsIntermediate from '@/components/PublicationsIntermediate'

export default {
  name: 'publications',
  components: {
    PublicationsAPIpubl, PublicationsNSTUpubl, PublicationsIntermediate
  }
}
</script>
